import * as React from 'react';
import {
    Checkbox,
    FormControlLabel,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from '@material-ui/core';
import { FiEdit3, FiX } from 'react-icons/fi';

import { connect, useDispatch } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { useSelector } from 'react-redux';
import useStyles from '../styles/styles';

const formName = 'battery-form';

const columns = [
    { field: 'id', headerName: 'Extra', width: 150 },
    {
        field: 'description',
        headerName: 'Description',
        width: 400,
    },
    {
        field: 'amount',
        headerName: 'Amount',
        type: 'number',
        width: 150,
    },
    {
        field: 'itemise',
        headerName: 'Itemise',
        width: 150,
    },
];

const columnsMobile = [
    { field: 'id', headerName: 'Extra', width: '50%' },
    {
        field: 'amount',
        headerName: 'Amount',
        type: 'number',
        width: '40%',
    },
    {
        field: 'itemise',
        headerName: 'Itemise',
        width: '10%',
    },
];

const ExtraRow = ({ row, formValues }) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    let extraArr = formValues && formValues['formchoice_extra'] ? JSON.parse(formValues['formchoice_extra']) : {};
    const getAttributeFromForm = () => {
        if (typeof extraArr[row.part_number] !== 'undefined' && extraArr[row.part_number] !== null) {
            return extraArr[row.part_number];
          }
        return [];
    }

    const extraAttr = getAttributeFromForm();
    let isItemise = extraAttr.itemise ? extraAttr.itemise : false;
    let cost = extraAttr.cost ? extraAttr.cost : row.cost;
    const [isSelect, setIsSelect] = React.useState(extraAttr.name ? true : false);
    const [isEdit, setIsEdit] = React.useState(false);
    const isLayout = useSelector((state) => state.shell.layout);

    const addExtra = () => {
        extraArr[row.part_number] = {
            name: row.name,
            cost: cost,
            itemise: isItemise
        }
        // set current value to field
        dispatch(change(formName, 'formchoice_extra', JSON.stringify(extraArr)));
    }

    const removeExtra = () => {
        delete extraArr[row.part_number];
        // set current value to field
        dispatch(change(formName, 'formchoice_extra', JSON.stringify(extraArr)));
    }
    
    const rowSelectHandler = (event) => {
        setIsSelect(event.target.checked);
        // add value to array
        if (event.target.checked) {
            addExtra();
        } else {
            // check extra exist in array
            if (extraArr[row.part_number] !== null && typeof extraArr[row.part_number] !== 'undefined') {
                removeExtra();
            }
        }
    }

    const amountChangeHandle = (event) => {
        cost = event.target.value;
        // add value to array
        addExtra();
    }

    const editOnClickHandle = () => {
        setIsEdit((prev) => !prev);
    }

    const itemiseSelectHanlder = (event) => {
        isItemise = event.target.checked;
        // add value to array
        addExtra();
    }

    return <TableRow>
        <TableCell align="left" variant="body" style={{width: '30%'}}>
            <FormControlLabel
                className={classes.unselectable}
                control={
                    <Checkbox
                        checked={isSelect}
                        name={row.part_number}
                        color="primary"
                        onClick={event => rowSelectHandler(event)}
                    />
                }
                label={row.name}
            />
        </TableCell>
        {isLayout === 0 &&
            <TableCell align="left" variant="body">
                {row.description}
            </TableCell>
        }
        <TableCell align="left" variant="body" padding="none" style={{width: '20%'}}>
            <TextField
                className={classes.amountInput}
                type="number"
                id={`price_${row.part_number}`}
                name={`price_${row.part_number}`}
                value={parseFloat(cost)}
                onChange={amountChangeHandle}
                disabled={!isSelect || (isSelect && !isEdit)}
                variant="outlined"
                fullWidth={false}
                size="small"
                fontSize="14px"
            />
            {isSelect &&  <IconButton onClick={editOnClickHandle} style={{fontSize: '20px', marginTop: '7px'}}>
                {isEdit ? <FiX id={`edit_price_${row.part_number}`} /> : <FiEdit3 id={`edit_price_${row.part_number}`} />}
            </IconButton>}
        </TableCell>
        <TableCell align="left" variant="body" padding="none">
            {isSelect && <Checkbox
                id={row.part_number + '_itemise'}
                color="primary"
                checked={isItemise}
                onClick={event => itemiseSelectHanlder(event)}
            /> }
        </TableCell>
    </TableRow>
}

const ExtraRowConnect = connect(
    state => ({
        formValues: getFormValues(formName)(state)
    }))(ExtraRow);

const PeExtraField = () => {
    const classes = useStyles();
    const state = useSelector((state) => {
        const shell = state.shell
        return ({
          shell
        });
      });
    const { extras } = state.shell?.productData;
    const isLayout = useSelector((state) => state.shell.layout);

    return (
        <div className={classes.PeExtraField_control}>
            <TableContainer component={Paper} className={classes.table}>
                <Table aria-label="caption table">
                    <TableHead>
                        {isLayout === 0 ?
                            <TableRow>
                                {columns.map((column, index) => (
                                    <TableCell key={index} align="left">
                                        {column.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                        :   <TableRow>
                                {columnsMobile.map((column, index) => (
                                    <TableCell key={index} align="left" width={column.width}>
                                        {column.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                        }
                        
                    </TableHead>
                    <TableBody>
                        {extras.map((row, index) => {
                            return <ExtraRowConnect id={row.part_number} key={index} row={row}/>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default PeExtraField;
